var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "industry-teaser grid grid__base" }, [
    _c("div", { staticClass: "grid--container" }, [
      _c("div", { staticClass: "industry-teaser--row grid--row" }, [
        _c("div", { staticClass: "industry-teaser--col grid--col" }, [
          _c(
            "div",
            {
              ref: "slider",
              staticClass: "industry-teaser--swiper-container swiper-container"
            },
            [
              _vm.swiper
                ? _c(
                    "div",
                    { staticClass: "industry-teaser--pagination-wrapper" },
                    _vm._l(_vm.items, function(item, idx) {
                      return _c(
                        "button",
                        {
                          key: idx,
                          staticClass: "industry-teaser--pagination-item",
                          class: _vm.getActiveFacet(idx, "pagination-item"),
                          on: {
                            click: function($event) {
                              _vm.goToSlide(idx)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(item.industry) +
                              "\n                        "
                          )
                        ]
                      )
                    })
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "industry-teaser--content-wrapper swiper-wrapper"
                },
                _vm._l(_vm.items, function(item, idx) {
                  return _c(
                    "div",
                    {
                      key: idx,
                      staticClass: "industry-teaser--slide swiper-slide",
                      class: _vm.getActiveFacet(idx, "slide"),
                      on: {
                        click: function($event) {
                          _vm.onSlideClicked($event, idx)
                        }
                      }
                    },
                    [
                      _c(
                        "morph-component",
                        {
                          staticClass:
                            "link link__flex-element industry-teaser--slide-content",
                          attrs: {
                            "default-component": "dyn-content-teaser",
                            components: { "<=sm": "dyn-content-card" },
                            slots: ["title", "content", "image", "links"],
                            facets: [
                              "industry-teaser",
                              "circle-header",
                              "same-height"
                            ]
                          }
                        },
                        [
                          _c(
                            "h3",
                            {
                              staticClass: "u-reset",
                              attrs: { slot: "morph-title" },
                              slot: "morph-title"
                            },
                            [_vm._v(_vm._s(item.title))]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "u-reset industry-teaser--description",
                              attrs: { slot: "morph-content" },
                              slot: "morph-content"
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(item.description) +
                                  "\n                                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "u-reset link link__no-underline link__icon",
                              attrs: {
                                slot: "morph-links",
                                href: item.link.path
                              },
                              slot: "morph-links"
                            },
                            [
                              _c("span", { staticClass: "link--label" }, [
                                _vm._v(_vm._s(item.link.label))
                              ]),
                              _vm._v(" "),
                              _c("base-icon", {
                                staticClass: "link--icon",
                                attrs: { symbol: "arrow-right", size: "small" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isOnMobile
                            ? _c(
                                "picture-element",
                                _vm._b(
                                  {
                                    attrs: { slot: "morph-image" },
                                    slot: "morph-image"
                                  },
                                  "picture-element",
                                  item.video_fallback_dict,
                                  false
                                )
                              )
                            : _c(
                                "is-visible",
                                {
                                  staticClass: "industry-teaser--video-wrapper",
                                  attrs: { slot: "morph-image" },
                                  slot: "morph-image"
                                },
                                [
                                  _c("dyn-lazy-video", {
                                    attrs: {
                                      "webm-src":
                                        item.visual_video_webm.urls.default[
                                          _vm.videoResolutionPositionIndex
                                        ],
                                      "mp4-src":
                                        item.visual_video_mp4.urls.default[
                                          _vm.videoResolutionPositionIndex
                                        ],
                                      poster:
                                        item.visual_video_poster.urls
                                          .default[0],
                                      fallback:
                                        item.video_fallback_dict.urls
                                          .default[0],
                                      loop: true,
                                      facets: ["industry-teaser"]
                                    }
                                  })
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "industry-teaser--mobile-pagination-wrapper"
              })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "industry-teaser--row grid--row" }, [
        _c(
          "div",
          { staticClass: "industry-teaser--cta-col grid--col" },
          [_vm._t("cta")],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3eb2a03b", { render: render, staticRenderFns: staticRenderFns })
  }
}